"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _MediaCreativeLayer2 = _interopRequireDefault(require("./MediaCreativeLayer"));

var _isEmptyString = _interopRequireDefault(require("../../utils/object/isEmptyString"));

var _isNil = _interopRequireDefault(require("../../utils/object/isNil"));

var _getVideoRelativeFrameIndicesAndTimesForFrame = _interopRequireDefault(require("../../utils/video-extraction/getVideoRelativeFrameIndicesAndTimesForFrame"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var AudioCreativeLayer = /*#__PURE__*/function (_MediaCreativeLayer) {
  (0, _inherits2["default"])(AudioCreativeLayer, _MediaCreativeLayer);

  var _super = _createSuper(AudioCreativeLayer);

  /* audio URL */

  /* If audio has been processed */
  function AudioCreativeLayer(element, content, media) {
    var _this;

    (0, _classCallCheck2["default"])(this, AudioCreativeLayer);
    _this = _super.call(this, element, content, media);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_audioURL", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_processedAudio", false);
    _this._processedAudio = media.processedAudio;
    _this._audioURL = AudioCreativeLayer.getAudioURL((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(AudioCreativeLayer, [{
    key: "getRelativeFrameIndicesAndTimesAtFrame",

    /**
     * Determine frame indices based on the current frame and global frame numbers
     *
     * @param {number} frameNumber
     */
    value: function getRelativeFrameIndicesAndTimesAtFrame(frameNumber) {
      var content = this.content,
          element = this.element,
          media = this.media;
      var contentEndInSeconds = content.end,
          contentStartInSeconds = content.start;
      var elementStart = element.frameStart;
      var duration = media.duration;
      var totalTime = this.creativeNumberOfFrames / this.creativeFrameRate;
      return (0, _getVideoRelativeFrameIndicesAndTimesForFrame["default"])(contentStartInSeconds, contentEndInSeconds, duration, elementStart, frameNumber, totalTime, this.creativeFrameRate);
    }
  }, {
    key: "audioURL",
    get: function get() {
      return this._audioURL;
    },
    set: function set(value) {
      this._audioURL = value;
    }
  }, {
    key: "processedAudio",
    get: function get() {
      return this._processedAudio;
    },
    set: function set(value) {
      this._processedAudio = value;
    }
  }], [{
    key: "getAudioURL",
    value: function getAudioURL(audibleCreativeLayer) {
      if ((0, _isNil["default"])(audibleCreativeLayer.media)) return null;
      var _audibleCreativeLayer = audibleCreativeLayer.media,
          audioServerId = _audibleCreativeLayer.audioServerId,
          processedAudio = _audibleCreativeLayer.processedAudio;

      if ((0, _isEmptyString["default"])(audioServerId)) {
        // If there is no audioServerId but processedAudio is true assume there is no audio.
        if (processedAudio) {
          return null;
        }

        return audibleCreativeLayer.mediaURL;
      }

      return "/api/v1/media/".concat(audioServerId, "/file");
    }
    /**
     * Checks if object is an instance of AudioCreativeLayer
     *
     * @param inputObject
     * @returns {boolean}
     */

  }, {
    key: "isAudioCreativeLayer",
    value: function isAudioCreativeLayer(inputObject) {
      return inputObject instanceof AudioCreativeLayer;
    }
  }]);
  return AudioCreativeLayer;
}(_MediaCreativeLayer2["default"]);

exports["default"] = AudioCreativeLayer;